export default "__VITE_ASSET__Ct7cOi_a__"